import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN?.trim();

export function initSentry(): void {
    if (!dsn) {
        return;
    }

    Sentry.init({
        dsn,
        environment:
            process.env.REACT_APP_SENTRY_ENVIRONMENT?.trim() ||
            process.env.NODE_ENV ||
            'production',
        release: process.env.REACT_APP_SENTRY_RELEASE?.trim(),
        tracesSampleRate: Number(
            process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? 0.1
        ),
    });
}

export { Sentry };
